import { createSlice } from '@reduxjs/toolkit';

const notificationClickInitialState = {
  isClick: false,
  date: null,
};

export const notificationClickSlice = createSlice({
  name: 'notificationClick',
  initialState: notificationClickInitialState,
  reducers: {
    changeClick: (state, action) => {
      state.isClick = action.payload.isClick;
      state.date = action.payload.date;
    },
    resetClick: (state) => {
      state.isClick = false;
      state.date = null;
    },
  },
});

export const { changeClick, resetClick } = notificationClickSlice.actions;

export default notificationClickSlice.reducer;
